module.exports = __webpack_public_path__ + "img/send.5887ef10.svg";